import { render } from "./Status.vue?vue&type=template&id=07964949&ts=true"
import script from "./Status.vue?vue&type=script&lang=ts"
export * from "./Status.vue?vue&type=script&lang=ts"

import "./Status.vue?vue&type=style&index=0&id=07964949&lang=scss"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__